import React, { Suspense, lazy } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './components/ThemeContext';
import { PartnerModalProvider } from './components/PartnerModalContext';
import PartnerModal from './components/PartnerModal';

import Events from './pages/Events';
import EventDetails from './pages/EventDetails';

const Resources = lazy(() => import('./pages/Resources'));
const Subscribe = lazy(() => import('./pages/Subscribe'));
// Lazy load pages for better performance
const Home = lazy(() => import('./pages/Home'));
const OurTeam = lazy(() => import('./pages/About/OurTeam'));
const OurStory = lazy(() => import('./pages/About/OurStory'));
const Contact = lazy(() => import('./pages/Contact'));
const StudentChapter = lazy(() => import('./pages/JoinUs/StudentChapter'));
const BecomePartner = lazy(() => import('./pages/JoinUs/BecomePartner'));
const Mentorship = lazy(() => import('./pages/Programs/Mentorship'));
const CybersecurityBasics = lazy(() => import('./pages/Programs/CybersecurityBasics'));
const EthicalHacking = lazy(() => import('./pages/Programs/EthicalHacking'));
const Certification = lazy(() => import('./pages/Programs/Certification'));
const NetworkingSummit = lazy(() => import('./pages/Programs/NetworkingSummit'));
const AwarenessWorkshop = lazy(() => import('./pages/Programs/AwarenessWorkshop'));
const WomenInCyberPanel = lazy(() => import('./pages/Programs/WomenInCyberPanel'));

function App() {
  return (
    <ThemeProvider>
      <PartnerModalProvider>
        <BrowserRouter>
          <div className="App">
            <Navbar />
            <PartnerModal />
            <Suspense fallback={<div style={{padding: '4rem', textAlign: 'center'}}>Loading...</div>}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about/OurTeam" element={<OurTeam />} />
                <Route path="/about/our-story" element={<OurStory />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/joinus/student-chapter" element={<StudentChapter />} />
                <Route path="/joinus/become-partner" element={<BecomePartner />} />
                <Route path="/programs/mentorship" element={<Mentorship />} />
                <Route path="/programs/cybersecurity-basics" element={<CybersecurityBasics />} />
                <Route path="/programs/ethical-hacking" element={<EthicalHacking />} />
                <Route path="/programs/certification" element={<Certification />} />
                <Route path="/programs/networking-summit" element={<NetworkingSummit />} />
                <Route path="/programs/awareness-workshop" element={<AwarenessWorkshop />} />
                <Route path="/programs/women-in-cyber-panel" element={<WomenInCyberPanel />} />
                <Route path="/resources" element={<Resources />} />
                <Route path="/subscribe" element={<Subscribe />} />
                <Route path="/events" element={<Events />} />
                <Route path="/events/:id" element={<EventDetails />} />
                {/* Add more routes as needed */}
              </Routes>
            </Suspense>
            <Footer />
          </div>
        </BrowserRouter>
      </PartnerModalProvider>
    </ThemeProvider>
  );
}

export default App;
